import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";


import { defaultSAL2070_R01Filter, SAL2070_R01Filter, useSAL2070_R01Store } from 'src/containers/mes/SAL/SAL2070_R01/Store_SAL2070_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { AgGridReact } from 'ag-grid-react';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { deleteSAL2070_R01, downloadExcel_SAL2070_R01, getPdfBlob_SAL2070_R01, getSAL2070_R01CreateInfo, getSAL2070_R01DetailInfo, getSAL2070_R01DetailList, getSAL2070_R01List, postSAL2070_R01 } from "./Api_SAL2070_R01";
import { defaultSAL2070_R01Dto, SAL2070_R01Dto, } from './Dto_SAL2070_R01';
import { validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';

interface Props {
	gridRef: React.RefObject<AgGridReact<SAL2070_R01Dto> | null>;
	detailGridRef: React.RefObject<AgGridReact<SAL2070_R01Dto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_SAL2070_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { moneyCdList, vatTypeList, vatIoFlagList, compCdList, customCdList, employeeCdList } = useCommonCodeStore();

	
	const {
		SAL2070_R01Filter, setSAL2070_R01Filter,
		SAL2070_R01PastFilter, setSAL2070_R01PastFilter,
		SAL2070_R01List, setSAL2070_R01List,
		editSAL2070_R01, setEditSAL2070_R01,
		selectedSAL2070_R01, setSelectedSAL2070_R01, 
		deletedSAL2070_R01DetailList, setDeletedSAL2070_R01DetailList, addDeletedSAL2070_R01DetailList, removeDeletedSAL2070_R01DetailList, 
		selectedSAL2070_R01DetailList, setSelectedSAL2070_R01DetailList, addSelectedSAL2070_R01DetailList, removeSelectedSAL2070_R01DetailList,
		SAL2070_R01DetailList, setSAL2070_R01DetailList, insertSAL2070_R01DetailList,
		originalSAL2070_R01DetailList, setOriginalSAL2070_R01DetailList,
		allCount, setAllCount,
		initData,
		setScrollTop, setDetailScrollTop,
	} = useSAL2070_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("SAL2070_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedSAL2070_R01 || !selectedSAL2070_R01.taxBillNo) {
				showWarning("출력할 세금계산서를 선택하세요.");
				setMessage("출력할 세금계산서를 선택하세요.");
				return;
			}
			setLoadingSpinner(true);
			try {
				// 기본적으로 집계 모드로 출력 (AGG)
				const blob = await getPdfBlob_SAL2070_R01(selectedSAL2070_R01.taxBillNo, 'AGG');
				if (qz.websocket.isActive()) {
					const ok = await printPdfFromBlob(blob, "report1");
					if (ok) {
						showSuccess("PDF 출력을 완료하였습니다.");
					} else {
						const fileURL = URL.createObjectURL(blob);
						window.open(fileURL, "_blank");
						setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
						showWarning("QZ 출력 실패로 브라우저 미리보기로 대체합니다.");
					}
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					showSuccess("PDF를 새 탭에서 열었습니다.");
				}
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			} finally {
				setLoadingSpinner(false);
			}
		}, [selectedSAL2070_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);

	// 상세 출력 모드 함수 추가
	const handlePrintDetailClick = async () => {
		if (!selectedSAL2070_R01 || !selectedSAL2070_R01.taxBillNo) {
			showWarning("출력할 세금계산서를 선택하세요.");
			setMessage("출력할 세금계산서를 선택하세요.");
			return;
		}
		setLoadingSpinner(true);
		try {
			// 상세 모드로 출력 (EXPAND)
			const blob = await getPdfBlob_SAL2070_R01(selectedSAL2070_R01.taxBillNo, 'EXPAND');
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					// showWarning("QZ 출력 실패로 브라우저 미리보기로 대체합니다.");
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			setMessage("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	};
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedSAL2070_R01) {
			showWarning("선택된 세금계산서 정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_SAL2070_R01('', selectedSAL2070_R01.tradeNo, SAL2070_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '세금계산서 정보전표 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedSAL2070_R01])

	const getParams = (filter: SAL2070_R01Filter) => {
		const params: Partial<SAL2070_R01Filter> = {
			compCd: filter.compCd || undefined,
			customCd: filter.customCd || undefined,
			dateRange: filter.dateRange || undefined,
			taxBilling: filter.taxBilling || undefined,
			tradeType: filter.tradeType || undefined,
		};
		return params;
	}

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);		

		const responseData = (await getSAL2070_R01List(
			'',
			getParams(SAL2070_R01Filter),
			SAL2070_R01List.length ?? 0
		));

		let newList = [...responseData.data.data ] as SAL2070_R01Dto[];
		setSAL2070_R01List(newList);

		const responseAllCount = responseData.data.data[0]?.allCount;
		const processAllCount = responseAllCount === null || responseAllCount === undefined
			? SAL2070_R01List.length : responseAllCount;

		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedSAL2070_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedSAL2070_R01?.salBillNo)
			);
			setSAL2070_R01PastFilter(SAL2070_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedSAL2070_R01(undefined);
			setSAL2070_R01List([]);
			setSAL2070_R01DetailList([]); 
			setDeletedSAL2070_R01DetailList([]);
			setSelectedSAL2070_R01DetailList([]);
			setOriginalSAL2070_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [SAL2070_R01Filter, SAL2070_R01List, setSAL2070_R01List, setSAL2070_R01PastFilter, setSelectedSAL2070_R01, selectedSAL2070_R01, setScrollTop, setDetailScrollTop])
	

	const fetchDetailList = useCallback(async () => {
		if (!selectedSAL2070_R01) return [];
		setDetailScrollTop(null);

		const responseData = (await getSAL2070_R01DetailList(selectedSAL2070_R01)).data.data;
		if (responseData && responseData.length > 0) {
			const newList = responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
				price: value.price,
			}));
			setSAL2070_R01DetailList(newList);
			setOriginalSAL2070_R01DetailList(responseData);
			setMessage(`${selectedSAL2070_R01?.customNm}의 세금계산서 정보내역 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
			return newList;
		} else {
			setSAL2070_R01DetailList([]);
			setOriginalSAL2070_R01DetailList([]);
			return [];
		}
	}, [selectedSAL2070_R01, initData, setSAL2070_R01DetailList, setOriginalSAL2070_R01DetailList, setMessage, setDetailScrollTop]);

	const processVatRate = useCallback((vatType: string) => {
		return Number(vatTypeList.find(item => item.minorCd === vatType)?.ref01 || 0) as number;
	}, [vatTypeList]);

	const defaultSAL2070_R01HeaderRow = useCallback(() => {
		return {
			...defaultSAL2070_R01Dto,
			compCd: compCdList[0].compCd,
			moneyCd: moneyCdList[0].minorCd,
			vatType: vatTypeList[0].minorCd,
			vatRate: processVatRate(vatTypeList[0].minorCd),
			taxBilling: vatIoFlagList[0].minorCd,
			inserted: true,
		}
	}, [defaultSAL2070_R01Dto, compCdList]);

	const fetchOne = useCallback(async (detailList: SAL2070_R01Dto[]) => {
		if (!selectedSAL2070_R01) return;

		const responseData = (await getSAL2070_R01DetailInfo(selectedSAL2070_R01)).data.data;
		if (responseData) {
			setEditSAL2070_R01({
				...defaultSAL2070_R01HeaderRow,
				...responseData,
				billAmt: Number(responseData.billAmt),
				vatAmt: Number(responseData.vatAmt),
			});

			if (responseData.taxBilling === 'Y') {
				setSelectedSAL2070_R01DetailList(detailList.map(value => value.tradeNo));
			}
		}
	}, [selectedSAL2070_R01, defaultSAL2070_R01HeaderRow, setEditSAL2070_R01, setSelectedSAL2070_R01DetailList]);

	const validateRefetchList = (value: SAL2070_R01Dto, processTrade: SAL2070_R01Dto) => {
		return value.taxBilling === 'N'
			&& value.tradeType === processTrade.tradeType
			&& value.tradeDt === processTrade.tradeDt
			&& value.customCd === processTrade.customCd
			&& (value.taxEmpNo === null || value.taxEmpNo === undefined )
	}

	const validateRefetchInfo = (value: SAL2070_R01Dto, processTrade: SAL2070_R01Dto) => {
		return value.taxBilling !== 'Y'
			&& value.tradeType === processTrade.tradeType
			&& value.tradeDt === processTrade.tradeDt
			&& value.customCd === processTrade.customCd
			&& (value.taxEmpNo === null || value.taxEmpNo === undefined )
	}

	const initContainerData = useCallback(() => {
		initData();
	}, [initData]);
	
	const handleDeleteClick = useCallback(async () => {

		if(!selectedSAL2070_R01){
			showWarning('세금계산서 정보내역을 선택해주세요.');
			return;
		}
		if(selectedSAL2070_R01.taxBilling !== 'Y'){
			showWarning('발행한 세금계산서만 삭제가 가능합니다.');
			return;
		}
		
		if (!window.confirm('정말로 삭제하시겠습니까?')) {
			return;
		}

		let processTrade = selectedSAL2070_R01;
		
		await deleteSAL2070_R01(selectedSAL2070_R01, selectedSAL2070_R01DetailList);
		showSuccess(`${processTrade.taxBillNo} 세금계산서 정보 삭제가 완료되었습니다.`);

		let refetchList = SAL2070_R01List.filter(value => value.valueIndex !== processTrade.valueIndex);
		refetchList = refetchList.map(value => {
			if(validateRefetchList(value, processTrade)){
				return {
					...value,
					totalAmt: value.totalAmt + processTrade.totalAmt,
				}
			}
			return value;
		});
		setSAL2070_R01List(refetchList);

		let refetchInfo = refetchList.find(value => validateRefetchInfo(value, processTrade));

		if(refetchInfo){
			setSelectedSAL2070_R01(refetchInfo);
		}else{
			setSelectedSAL2070_R01(undefined);
		}

		// 기본키가 없는 그리드이므로 refetchUpdateList 사용 시 문제 발생
		// refetchUpdateList('delete', defaultSAL2070_R01Dto, selectedSAL2070_R01, 'taxEmpNo', SAL2070_R01List, setSAL2070_R01List);
		
	}, [selectedSAL2070_R01, SAL2070_R01List]);
	
	const handleCreateClick = () => {
		setSelectedSAL2070_R01(undefined);
		setEditSAL2070_R01(defaultSAL2070_R01HeaderRow());
		setSAL2070_R01DetailList([{...defaultSAL2070_R01HeaderRow(), inserted: true}]);
		setDeletedSAL2070_R01DetailList([]);
		setSelectedSAL2070_R01DetailList([]);
		setOriginalSAL2070_R01DetailList([]);
		setDetailScrollTop(null);
	}

	const validateInsertData = (header: SAL2070_R01Dto, detailList: SAL2070_R01Dto[]) => {

		if (!header.issuedDt) {
			showWarning('세금계산서일자를 입력해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateString(header.taxEmpNo)) {
			showWarning('세금계산서 담당자를 입력해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.taxEmpNo, employeeCdList)) {
			showWarning('세금계산서 담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (header.vatRate === undefined) {
			showWarning('부가세율을 입력해주세요.'); return false;
		}
		if (selectedSAL2070_R01DetailList.length === 0) {
			showWarning('상세내역이 없습니다.'); return false;
		}

		return true;
	}
	
	const handleSaveClick = useCallback(async () => {

		if(editSAL2070_R01?.taxBilling === "Y") { showWarning('발행한 세금계산서는 수정이 불가능합니다.'); return; }
		if(SAL2070_R01DetailList.length === 0) { showWarning('발행할 거래 상세내역이 없습니다.'); return; }

		let valid = true;
		if(!validateInsertData(editSAL2070_R01!, SAL2070_R01DetailList)) valid = false;
		if(!valid) { return; }
		
		let processName = '';
		let newHeaderList: SAL2070_R01Dto[] = [];
		let responseData: SAL2070_R01Dto = {
			...editSAL2070_R01!,
		};
		let postInfoResponse: SAL2070_R01Dto = {
			...defaultSAL2070_R01HeaderRow(),
		};

		if (selectedSAL2070_R01) {
			
			if(selectedSAL2070_R01DetailList.length > 0){
				
				processName = 'post';
				const postResponse = await postSAL2070_R01(editSAL2070_R01!, selectedSAL2070_R01DetailList);
				responseData = postResponse.data.data;

				//갱신할 데이터는 헤더 데이터만 갱신. taxBillNo는 비워둬서 새로 발급한 세금계싼서 정보 불러오기
				const processResponseData = {
					...responseData,
					taxBillNo: '',
				}
				
				if (processResponseData && postResponse.data.successFlag) {
					showSuccess('세금계산서 정보 등록에 성공하였습니다.');
					setMessage('세금계산서 정보 등록에 성공하였습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('세금계산서 정보 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					return;
				}

				//만약 selectedSAL2070_R01DetailList 값이 1 이상이라면 이후 추가한 세금계산서 정보 표기
				
				if(selectedSAL2070_R01DetailList.length > 1){
					postInfoResponse = {
						...processResponseData, // responseData에서 헤더를 가져옵니다.
						...(await getSAL2070_R01CreateInfo(responseData)).data.data
					}
				}else{
					postInfoResponse = (await getSAL2070_R01CreateInfo(responseData)).data.data;
				}

				//세금계산서 항목을 모두 선택하고 저장버튼을 누르면 기존 row는 삭제 
				//세금계산서 항목을 일부 선택하고 저장버튼을 누르면 선택한 세금계산서 항목의 거래금액 수정
				let pastList = SAL2070_R01List;
				if(selectedSAL2070_R01DetailList.length === SAL2070_R01DetailList.length){
					pastList = SAL2070_R01List.filter(value => value.valueIndex !== selectedSAL2070_R01.valueIndex);
				}else{
					
					pastList = SAL2070_R01List.map(value => {
						if(selectedSAL2070_R01.valueIndex === value.valueIndex){
							return {
								...value,
								totalAmt: value.totalAmt - responseData.totalAmt,
							}
						}
						return value;
					});
				}

				newHeaderList = [
					postInfoResponse,
					...pastList,
				] as SAL2070_R01Dto[];
			}
		} //수정은 없음


		if (processName === 'post') {
			
			setSAL2070_R01List(newHeaderList);
			setSelectedSAL2070_R01(postInfoResponse);
		}

		// setSelectedSAL2070_R01(undefined);
		setDeletedSAL2070_R01DetailList([]);
		setSelectedSAL2070_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		editSAL2070_R01, 
		selectedSAL2070_R01, 
		SAL2070_R01DetailList, 
		deletedSAL2070_R01DetailList, 
		SAL2070_R01List, setSAL2070_R01List
	]);

	useEffect(() => {
		setSelectedSAL2070_R01DetailList([]);

		if(selectedSAL2070_R01){
			const runAsyncFetches = async () => {
				if (selectedSAL2070_R01) {
					const detailList = await fetchDetailList();
					if (selectedSAL2070_R01.taxBilling === 'Y' && detailList.length > 0) {
						await fetchOne(detailList);
					}
				}
			};

			runAsyncFetches();

			const processVatRate = (vatType: string) => {
				return Number(vatTypeList.find(item => item.minorCd === vatType)?.ref01 || 0) as number;
			}

			const latestEdit = useSAL2070_R01Store.getState().editSAL2070_R01;
			const defaultCompCd = compCdList[0]?.compCd ?? '';
			const nextCompCd = selectedSAL2070_R01.taxBilling !== 'Y'
				? defaultCompCd
				: (latestEdit?.compCd ?? defaultCompCd);

			if (latestEdit?.vatType && vatTypeList.length > 0) {
				setEditSAL2070_R01({
					...latestEdit,
					compCd: nextCompCd,
					vatRate: processVatRate(latestEdit.vatType),
				});
			} else {
				setEditSAL2070_R01({
					...latestEdit!,
					compCd: nextCompCd,
					vatRate: processVatRate(vatTypeList[0].minorCd),
				});
			}
		}else{
			setEditSAL2070_R01(defaultSAL2070_R01HeaderRow());
			setSAL2070_R01DetailList([]);
			setDeletedSAL2070_R01DetailList([]);
			setSelectedSAL2070_R01DetailList([]);
			setOriginalSAL2070_R01DetailList([]);
		}
	}, [selectedSAL2070_R01, fetchDetailList, fetchOne]);

	useEffect(() => {
		if (selectedSAL2070_R01 && SAL2070_R01DetailList.length === 0) {
			insertSAL2070_R01DetailList([{ ...defaultSAL2070_R01HeaderRow() }])
		}
	}, [selectedSAL2070_R01, SAL2070_R01DetailList])
	
	return {
		handlePrintClick,
		handlePrintDetailClick,
		handleExcelClick,
		fetchData,
		processVatRate,
		defaultSAL2070_R01HeaderRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
